import { connect } from 'react-redux';
import {
  doAddToCartAndRefresh,
  doAddToCart,
} from 'shared/store/addToCart/action';
import { State } from 'store/types';
import View from './View';

const mapStateToProps = (state: State) => {
  const { auth, productPage, appReducer } = state;
  return {
    isPro: auth?.user?.isPro,
    isVariantSelected: !!productPage?.product?.selectedVariantId,
    isVariantsAvailable: !!productPage?.product?.variants?.length || false,
    device: appReducer.client.device,
    pageType: appReducer.pageType,
  };
};

const mapDispatchToProps = {
  doAddToCart,
  doAddToCartAndRefresh,
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
